import type { CmsContentTypes } from '@eneco/cms-types/generated';
import { DC_Domain_Models_Products_DiscontinueDisallowReason } from '@monorepo-types/dc';

/**
 * The four cancellation dialogs, as both adapters hand them over: each one flat, with its own
 * `title`, `content` and `triggerText`. Taken from one of the reason step's generated content
 * types; the others carry the same dialogs.
 */
export type CancellationDialogs = Pick<
  CmsContentTypes['CancelationReasonStep'],
  'cancelledAlreadyDialog' | 'minimumContractPeriodNotMetDialog' | 'multipleServiceContractsActiveDialog' | 'noActiveProductDialog'
>;

export const getDialogContent = (
  dialogs: CancellationDialogs | undefined,
  discontinueDialog: DC_Domain_Models_Products_DiscontinueDisallowReason | '',
  remainingMonths: number,
) => {
  const replaceContractPeriod = (text: string | undefined) => {
    return text ? text.replace('{contractPeriodRemaining}', remainingMonths.toString()) : '';
  };
  switch (discontinueDialog) {
    case 'cancelledAlready':
      return {
        title: dialogs?.cancelledAlreadyDialog?.title ?? '',
        content: dialogs?.cancelledAlreadyDialog?.content ?? '',
        triggerText: dialogs?.cancelledAlreadyDialog?.triggerText ?? '',
      };
    case 'minimumContractPeriod':
      return {
        title: replaceContractPeriod(dialogs?.minimumContractPeriodNotMetDialog?.title),
        content: dialogs?.minimumContractPeriodNotMetDialog?.content ?? '',
        triggerText: dialogs?.minimumContractPeriodNotMetDialog?.triggerText ?? '',
      };
    case 'moreThanOneMatchedProduct':
      return {
        title: dialogs?.multipleServiceContractsActiveDialog?.title ?? '',
        content: dialogs?.multipleServiceContractsActiveDialog?.content ?? '',
        triggerText: dialogs?.multipleServiceContractsActiveDialog?.triggerText ?? '',
      };
    case 'noActiveProduct':
      return {
        title: dialogs?.noActiveProductDialog?.title ?? '',
        content: dialogs?.noActiveProductDialog?.content ?? '',
        triggerText: dialogs?.noActiveProductDialog?.triggerText ?? '',
      };
  }
};
